'use strict';
import Vue from 'vue';
import Buefy from 'buefy';
import '@mdi/font/css/materialdesignicons.css';

import '@/assets/local/buefy.scss';
Vue.use(Buefy);

// #f6b93b
